const state = {
  unreadMessages: null,
  showOnInit: false,
  isOpen: false,
  hasEscalatedToIntercom: false,
  hasOpenedIntercom: false,
};

const getters = {
  shouldShowBar(state, _getters, _rootState, rootGetters) {
    if (!rootGetters['featureFlags/intercomBottomBar'] || state.isOpen) {
      return false;
    }
    return state.hasEscalatedToIntercom || state.hasOpenedIntercom || state.unreadMessages > 0;
  },
};

const actions = {
};

const mutations = {
  setUnreadMessages(state, unreadMessages) {
    state.unreadMessages = unreadMessages;
  },
  setShowOnInit(state, showOnInit) {
    state.showOnInit = showOnInit;
  },
  setIsOpen(state, isOpen) {
    state.isOpen = isOpen;
  },
  setHasEscalatedToIntercom(state, hasEscalatedToIntercom) {
    state.hasEscalatedToIntercom = hasEscalatedToIntercom;
  },
  setHasOpenedIntercom(state, hasOpenedIntercom) {
    state.hasOpenedIntercom = hasOpenedIntercom;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
